import { useEffect, useState } from "react";
import MenuBarComponent from "../Components/MenuBarComponent";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { recoverPasswordService, resetPasswordService, validateResetPasswordService } from "../Service/UserService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

function ChangePassword() {
    const { t } = useTranslation('recover_password');
    const navigate = useNavigate()
    const {code} = useParams()
    const [isValid, setIsvalid] = useState(false)

    const {
        register,
        getValues,
        handleSubmit,
        formState: { errors },
        } = useForm();
    useEffect(()=>{
        recoverPasswordValidation()
    },[])

    const recoverPasswordValidation = () => {
        code && validateResetPasswordService(code).then((res)=>{
            console.log(res)
            setIsvalid(res)
        }).catch((error)=>{
            toast.error(t(error.message))
        })
    }

    const onSubmit = (e) => {
        const {password} = e
        resetPasswordService(code, password).then(res=>{
            console.log(res)
            if (res) {
                toast.success(t('change_password_success'))
                navigate('/login')
            }
        }).catch(error=>{
            toast.error(error.message ? t(error.message) : t('recover_invalid_message'))
        })
    }

    return (
        <div className="flex flex-column gap-2">
            <MenuBarComponent />
            <div className="flex flex-column gap-4 align-items-center mt-4">
                <div className="text-xl md:text-3xl font-bold">{t('change_password_title')}</div>
                {isValid ? <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-4'>
                    <div className='flex flex-column gap-1'>
                        <label>{t('change_password_password')}<span className='form-validation-message'>*</span></label>
                        <InputText type='password' className='w-full' {...register('password', {
                            required: t('password_validation_message')})} />
                        {errors.password && <span className='form-validation-message'>{errors.password.message}</span>}
                    </div>

                    <div className='flex flex-column gap-1'>
                        <label>{t('change_password_confirm_password')}<span className='form-validation-message'>*</span></label>
                        <InputText type='password' className='w-full' {...register('confirm_password', {
                            required: t('confirm_password_validation_message'),
                            validate: (value) =>
                                value === getValues('password') || t('password_not_match'),})} />
                        {errors.confirm_password && <span className='form-validation-message'>{errors.confirm_password.message}</span>}
                    </div>
                    <div className="flex gap-2 justify-content-center">
                        <Button label={t('change_password_change_button')} type="submit" />
                        <Button label={t('cancel')} onClick={()=>navigate('/')} severity="secondary" />
                    </div>
                </form> : 
                <div className="flex flex-column gap-4 align-items-center">
                    <div>{t('change_password_invalid_code_message')}</div>
                    <Button label={t('change_password_recover_password_button')} onClick={()=>navigate('/recover_password')} />
                </div>}
            </div>
            
        </div>
    )
}

export default ChangePassword